import React from 'react';
import { Router, Route, Switch } from 'react-router-dom';
import { InteractionType } from '@azure/msal-browser';
import { MsalAuthenticationTemplate } from '@azure/msal-react';

import Director from 'modules/director';
import Admin from 'modules/admin';
import ErrorPage from 'modules/common/ErrorPage';
import history from 'browserHistory';
import PrivateRoute from 'modules/auth/components/PrivateRoute';
import Security from 'modules/security';
import Ordering from 'modules/ordering';
import { Login } from 'modules/auth/Login';
import Auth from 'modules/auth/containers/Auth';
import Kiosk from 'modules/kiosk';
import RoleUndefined from 'modules/auth/containers/RoleUndefined';
import Manager from 'modules/manager';
import { Tvpanel } from 'modules/tvpanel/containers/Tvpanel/Tvpanel';
import { RoleValues } from './entities/Roles';

function App() {
  return (
    <Router history={history}>
      <Switch>
        <Route path="/" exact component={Login} />
        <Route path="/role-undefined" component={RoleUndefined} />
        <Route path="/not-found" component={ErrorPage} />
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
          <Switch>
            <PrivateRoute path="/auth" component={Auth} roles="" />
            <PrivateRoute path="/security" component={Security} roles={[RoleValues.ARM_OHRANA]} />
            <PrivateRoute path="/ordering" component={Ordering} roles={[RoleValues.ARM_ORDERING]} />
            <PrivateRoute path="/admin" component={Ordering} roles={[RoleValues.ARM_SUPERUSER]} />
            <PrivateRoute path="/kiosk" component={Kiosk} roles={[RoleValues.ARM_KIOSK]} />
            <PrivateRoute path="/director" component={Director} roles={[RoleValues.ARM_DIRECTOR]} />
            <PrivateRoute path="/globaladmin" component={Admin} roles={[RoleValues.ARM_ADMINISTRATOR]} />
            <PrivateRoute path="/manager" component={Manager} roles={[RoleValues.ARM_MANAGER]} />
            <PrivateRoute path="/tvpanel" component={Tvpanel} roles={[RoleValues.ARM_TVPANEL]} />
          </Switch>
        </MsalAuthenticationTemplate>
      </Switch>
    </Router>
  );
}

export default App;
